module.exports = __webpack_public_path__ + "static/media/S_F01.3ef1d13f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/S_F01.png
// module id = 106
// module chunks = 0